// extracted by mini-css-extract-plugin
export default {"popover-content":"styles_popover-content__2LisB"};